import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../config/axios";
import config from "../config/index";

//Async thunk for fetching all U.S. states
export const fetchUsStates = createAsyncThunk(
  "usStates/fetchUsStates",
  async (_, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${config.apiBaseURL2}states`);
      if (res.data.status) {
        return res.data.data;
      } else {
        return rejectWithValue(res.data.message);
      }
    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch states");
    }
  }
);

const usStatesSlice = createSlice({
  name: "usStates",
  initialState: {
    list: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsStates.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUsStates.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchUsStates.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default usStatesSlice.reducer;
